import { MessageCircle } from "lucide-react";
import { useSettings } from "@/context/SettingsContext";

export default function WhatsAppFloat() {
  const { settings } = useSettings();
  const contact = settings?.contact || {};
  const phone = (contact.whatsappPhone || "").replace(/[^0-9]/g, "");
  if (!phone) return null;
  const message = encodeURIComponent(
    contact.whatsappMessage ||
      "Hello, I would like to know more about admissions at Ambigara Chowdaiah College of Nursing."
  );
  const href = `https://wa.me/${phone}?text=${message}`;

  return (
    <a
      data-testid="whatsapp-float-btn"
      href={href}
      target="_blank"
      rel="noopener noreferrer"
      className="fixed bottom-6 right-6 z-50 group"
      aria-label="Chat on WhatsApp"
    >
      <span className="absolute inset-0 rounded-full animate-wa-pulse" />
      <span className="relative flex items-center gap-2 bg-green-500 hover:bg-green-600 text-white rounded-full pl-3.5 pr-5 py-3.5 shadow-xl transition-transform group-hover:-translate-y-0.5">
        <MessageCircle className="w-5 h-5" />
        <span className="hidden sm:inline text-sm font-medium">Chat on WhatsApp</span>
      </span>
    </a>
  );
}
